export interface FeatureFlags {
  projects: boolean;
  reviews: boolean;
  aiDescriptionGeneration: boolean;
  skillSuggestions: boolean;
  teamFormation: boolean;
  richTextEditor: boolean;
  jobPreview: boolean;
  inAppNotifications: boolean;
  payments: boolean;
  quoteRequests: boolean;
  quoteManagement: boolean;
  regionalSearch: boolean;
  accessibilityMenu: boolean;
  proximitySearch: boolean;
  credit: boolean;
}

const defaultFeatures: FeatureFlags = {
  projects: false,
  reviews: false,
  aiDescriptionGeneration: true,
  skillSuggestions: true,
  teamFormation: true,
  richTextEditor: true,
  jobPreview: true,
  inAppNotifications: true,
  payments: false,
  quoteRequests: true,
  quoteManagement: true,
  regionalSearch: true,
  accessibilityMenu: true,
  proximitySearch: false,
  credit: false,
};

const parseEnvFeatures = (): FeatureFlags => {
  const features = { ...defaultFeatures };

  const parseBool = (value: string | undefined): boolean | undefined => {
    if (value === undefined) return undefined;
    return value.toLowerCase() === 'true';
  };

  const envFeatures = {
    aiDescriptionGeneration: parseBool(import.meta.env.VITE_FEATURE_AI_DESCRIPTION),
    skillSuggestions: parseBool(import.meta.env.VITE_FEATURE_SKILL_SUGGESTIONS),
    teamFormation: parseBool(import.meta.env.VITE_FEATURE_TEAM_FORMATION),
    richTextEditor: parseBool(import.meta.env.VITE_FEATURE_RICH_TEXT_EDITOR),
    jobPreview: parseBool(import.meta.env.VITE_FEATURE_JOB_PREVIEW),
    inAppNotifications: parseBool(import.meta.env.VITE_FEATURE_IN_APP_NOTIFICATIONS),
    payments: parseBool(import.meta.env.VITE_FEATURE_PAYMENTS),
    reviews: parseBool(import.meta.env.VITE_FEATURE_REVIEWS),
    quoteRequests: parseBool(import.meta.env.VITE_FEATURE_QUOTE_REQUESTS),
    quoteManagement: parseBool(import.meta.env.VITE_FEATURE_QUOTE_MANAGEMENT),
    regionalSearch: parseBool(import.meta.env.VITE_FEATURE_REGIONAL_SEARCH),
    accessibilityMenu: parseBool(import.meta.env.VITE_FEATURE_ACCESSIBILITY_MENU),
    credit: parseBool(import.meta.env.VITE_FEATURE_CREDIT),
  };

  Object.entries(envFeatures).forEach(([key, value]) => {
    if (value !== undefined) {
      features[key as keyof FeatureFlags] = value;
    }
  });

  return features;
};

export const features = parseEnvFeatures();
